// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    theme: 'nexus-dx',
    production: true,
    maxSimultaneousAlerts: 5,
    // apiUrl: 'https://booking-dev.previmo.de:4443',
    // apiUrl: 'http://localhost:3000',
    apiUrl: 'https://api.previmo.de',
    tokenRefreshThreshold: 1800,
    bookingLinkUrlTemplate: 'https://nexus-dx.previmo.de/mbd/booking?booking=<engagementID>',
    // bookingLinkUrlTemplate: 'http://localhost:4200/home?booking=<engagementID>',
    isMyBloodDrop: true,
    backgroundColor: '#F1F4F7',
    fontFamily: 'Lato'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.